import { FC, useState } from 'react';
import { defaultFn } from 'destiny/dist/constants';
import { useGetCountdown } from 'hooks';
import { defaultFnType } from 'types';

interface CoundownPropTypes {
  totalTime?: number;
  callback?: defaultFnType;
  title?: string;
  titleStyle?: string;
  countDownStyle?: string;
  disabledTitleStyle?: string;
  hideMinuteOnZero?: boolean;
}

const Countdown: FC<CoundownPropTypes> = ({
  totalTime = 65,
  callback = defaultFn,
  title = 'Resend OTP',
  titleStyle = 'tw-text-ZAMP_PRIMARY f-14-500',
  disabledTitleStyle = 'tw-text-TEXT_TERTIARY',
  countDownStyle = 'f-14-300',
  hideMinuteOnZero = false,
}) => {
  const [isOtpTimeoutOver, setIsOtpTimeoutOver] = useState(false);
  const { minutes, seconds, resetCountdown } = useGetCountdown(totalTime, () => {
    setIsOtpTimeoutOver(true);
  });

  const resend = () => {
    if (isOtpTimeoutOver) {
      resetCountdown();
      setIsOtpTimeoutOver(false);
      callback();
    }
  };

  return (
    <div className='tw-select-none' role='presentation' onClick={resend}>
      {!!title && (
        <span
          className={`${titleStyle} ${
            isOtpTimeoutOver ? ' tw-cursor-pointer' : `tw-cursor-not-allowed ${disabledTitleStyle}`
          }`}
        >
          {title}
        </span>
      )}
      {!isOtpTimeoutOver && (
        <span className={`${countDownStyle}`}>
          {' '}
          in {<span>{!(parseInt(minutes as string) === 0 && hideMinuteOnZero) && `${minutes} Min`} </span>}
          <span>{seconds} Sec</span>
        </span>
      )}
    </div>
  );
};

export default Countdown;
